<template>
  <div class="deck-plan-viewer">
    <div v-if="deckPlanUrl" class="deck-plan-container">
      <img 
        :src="deckPlanUrl" 
        alt="Deck Plan"
        class="deck-plan-image"
        @error="handleImageError"
      />
      <div class="deck-plan-actions">
        <a :href="deckPlanUrl" target="_blank" class="view-full-btn">
          <i class="fas fa-external-link-alt"></i>
          View Full Size
        </a>
      </div>
    </div>
    <div v-else class="no-deck-plan">
      <i class="fas fa-map"></i>
      <p>Deck plan not available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeckPlan',
  props: {
    deckPlanUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    handleImageError(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>

<style scoped>
.deck-plan-viewer {
  width: 100%;
}

.deck-plan-container {
  background-color: var(--cs-d-surface-alt);
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.deck-plan-image {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

.deck-plan-actions {
  margin-top: 16px;
}

.view-full-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: #1a73e8;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.view-full-btn:hover {
  background-color: #1557b0;
}

.no-deck-plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: var(--cs-d-muted);
  background-color: var(--cs-d-surface-alt);
  border-radius: 8px;
}

.no-deck-plan i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}
</style>

